"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mortgageSagas = void 0;
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var effects_1 = require("redux-saga/effects");
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var DetailPopTabType_1 = require("@/pages/detail/states/DetailPopTabType");
var MortgageTab_1 = require("@/pages/detail/states/MortgageTab");
var WindowApi_1 = require("@/api/browser/WindowApi");
var MortgageSagaCall_1 = require("@/pages/detail/sagas/MortgageSagaCall");
var getMortgageState = function (state) { return state.detail.mortgage; };
var watchInitResult = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.calcutateMorgage())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchMortgageInputChange = function () {
    var action, reload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take([DetailAction_1.default.DETAIL_ON_PRICE_CHANGE, DetailAction_1.default.DETAIL_ON_DOWNPAYMENT_CHANGE, DetailAction_1.default.DETAIL_ON_DURATION_CHANGE, DetailAction_1.default.DETAIL_ON_AVD_CHANGE, DetailAction_1.default.DETAIL_ON_BSD_CHANGE, DetailAction_1.default.DETAIL_ON_INTEREST_RATE_CHANGE, DetailAction_1.default.DETAIL_ON_HAS_TRANSACTED_RECENTLY_CHANGED, DetailAction_1.default.DETAIL_ON_HAS_TRANSACTED_RECENTLY_MONTH_CHANGED])];
            case 1:
                action = _a.sent();
                reload = action.payload.reload;
                if (!reload) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.calcutateMorgage())];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchCalculate = function () {
    var mortgageState, newMortgageState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_CALCULATE_MORTGAGE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getMortgageState)];
            case 2:
                mortgageState = _a.sent();
                return [4 /*yield*/, effects_1.call(MortgageSagaCall_1.getMortgageResult, mortgageState)];
            case 3:
                newMortgageState = _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setMortgage(newMortgageState))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchCalculateClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_CALCULATE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.onExpandClick(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.calcutateMorgage())];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.scrollToMortgageCalculatorTop)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchCustomizeClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_CUSTOMIZE_CAL_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopRender(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setPopActive(DetailPopTabType_1.DetailPopTabType.MORTGAGE))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.onMortgageTabClick(MortgageTab_1.MortgageTab.OVERVIEW))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchDonutHover = function () {
    var payload, item, index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(DetailAction_1.default.DETAIL_ON_DONUT_HOVER)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload.item;
                index = payload.index;
                return [4 /*yield*/, effects_1.put(DetailAction_1.default.setDonutActive(index))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var mortgageSagas = {
    watchInitResult: watchInitResult,
    watchMortgageInputChange: watchMortgageInputChange,
    watchCalculate: watchCalculate,
    watchCalculateClick: watchCalculateClick,
    watchCustomizeClick: watchCustomizeClick,
    watchDonutHover: watchDonutHover,
};
exports.mortgageSagas = mortgageSagas;
